import { render } from "./PostcardCreation.vue?vue&type=template&id=53859cf7&scoped=true"
import script from "./PostcardCreation.vue?vue&type=script&lang=js"
export * from "./PostcardCreation.vue?vue&type=script&lang=js"

import "./PostcardCreation.vue?vue&type=style&index=0&id=53859cf7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53859cf7"]])

export default __exports__